export function generateFileName(fileName?: string): string {
  const today = new Date();
  const dateStr = `${today.getDate().toString().padStart(2, '0')}-${(today.getMonth() + 1)
    .toString()
    .padStart(2, '0')}-${today.getFullYear()}`;

  if (fileName) {
    if (fileName.endsWith('.csv')) {
      return fileName.replace('.csv', `_${dateStr}.csv`);
    }
    return `${fileName}_${dateStr}.csv`;
  }

  return `File_${dateStr}.csv`;
}
